export default __webpack_public_path__ + "static/media/fire.fa5670ca.svg";